export const WHATSAPP_NUMBER = "522218628551";
export const WHATSAPP_MESSAGE =
  "Hola, quiero información sobre ERP Alimentos para mi restaurante.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE,
)}`;
export const WEBSITE_URL = "https://erpalimentos.com.mx";
export const WHATSAPP_DISPLAY = "+52 221 862 8551";

export const SLIDES_META = [
  { id: 1, key: "portada", label: "Portada" },
  { id: 2, key: "que-es", label: "¿Qué es?" },
  { id: 3, key: "objetivo", label: "Objetivo" },
  { id: 4, key: "contenido", label: "Módulos" },
  { id: 5, key: "pos", label: "Punto de venta" },
  { id: 6, key: "cocina", label: "Cocina" },
  { id: 7, key: "caja", label: "Caja" },
  { id: 8, key: "menu-qr", label: "Menú QR" },
  { id: 9, key: "web-delivery", label: "Web delivery" },
  { id: 10, key: "inventarios", label: "Inventarios" },
  { id: 11, key: "recetas", label: "Recetas" },
  { id: 12, key: "reservas", label: "Reservas" },
  { id: 13, key: "reportes", label: "Reportes" },
  { id: 14, key: "delivery", label: "Delivery propio" },
  { id: 15, key: "clientes", label: "Clientes" },
  { id: 16, key: "contratacion", label: "Contratación" },
  { id: 17, key: "contacto", label: "Contacto" },
];
